import React from 'react'
import {
    Grid,
  
    makeStyles, 
  

    CardContent, 
  
   } from '@material-ui/core';

import TblDetalleConsultasRutModal from './TblDetalleConsultasRutModal'
import TblDOcumentoPortalchqModal from './TblDOcumentoPortalchqModal'

//import FondoImagenes from '/static/imagen/fondo.jpg';
const useStyles = makeStyles((theme) => ({ 
    tituloTable: {

       backgroundColor: theme.palette.primary.main, 
       minWidth: 200,
       color: 'white',
       textAlign: 'center',
       padding: '20px',
       fontWeight: '250',
       fontSize : '35px'
    },  
    TituloIdentificacion: {

        backgroundColor: theme.palette.primary.main, 
        backgroundImage : `url(${process.env.PUBLIC_URL+'/static/imagen/fondo.jpg'})`,
        minWidth: 200,
        color: 'black',
        textAlign: 'left',
        padding: '15px',
        fontWeight: '450',
        fontSize : '18px',
        height: 'auto',
        alignContent: 'center',               
     },
    fondoTituloIndicadores: {

        backgroundColor: theme.palette.fondotitulos.main,
        minWidth: 200,
        color: '#171717',
        textAlign: 'center',
        padding: '15px',
        fontWeight: '250',
        fontSize : '18px',
        height: 'auto',
        alignContent: 'center',               
     },

    FondoTable :{
       
        backgroundColor: theme.palette.greyFondo.main
    }

}))

const AsignacionTableModal = () => {
    const classes = useStyles();
    return (
        <div>
            
            <Grid component="main">
            <div className={classes.TituloIdentificacion}>COMPORTAMIENTO</div>
          
            <CardContent>
            <Grid  container direction="row" spacing={2}>                         

            <Grid item xs={12} sm={12} xl={12} md={12} lg={12} >
               
              
                <div className={classes.fondoTituloIndicadores}>Documentos portal cheque</div>
                       
                    < TblDOcumentoPortalchqModal />
                
            </Grid>
         
        
           
            
            </Grid> 

            </CardContent>
        
         
            </Grid>
        </div>
    )
}

export default AsignacionTableModal;
